/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Login Form component

Author: Deimos Space UK

Version: 1.0
*/


import React from "react";
import {
	Card,
	CardBody,
	Button,
	Form,
	
} from "reactstrap";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/ESA_logo_2020_White.png";

export default function LoginForm() {

	const redirectLogin = () => {
		// Here you need to chagne the mise_next url to react route 
		// which will set react authentication set to true
		// and deal will extracting user information from REACT_APP_SERVER_URL+/api/userinfo and displaying it in avtar
		// and then navigating to '/existing_missions'
		let redirectURL = "";
		const currentURL = window.location.href;
		if (currentURL.startsWith("http://localhost:3000")) {
			redirectURL = process.env.REACT_APP_SERVER_URL+"/login"
		} else {
			redirectURL = process.env.REACT_APP_SERVER_URL+"/login"
		}
	window.location = redirectURL;
}

return (
	<>
		<Card>
			<div
				className="card-header align-center text-center"
				style={{ background: "#003247" }}
			>
				<Link to="/landing-login">
					<span>
						<img src={logo} alt="" height="200" />
					</span>
				</Link>
			</div>

			<CardBody className="p-4 position-relative">
				<Form>
					<div style={ {display:'flex', justifyContent:'center'}} className="mb-3 position-center" >
					<Button
						onClick={() => {
							redirectLogin();
						}}
						color="primaryEsa"
					>
						ESA SDO Login
					</Button>
					</div>
				</Form>
			</CardBody>
		</Card>
	</>
);
}
